import MaestroDirectiveProxy from "./maestro-directive-proxy";

export default class Maestro {
  constructor(
    options = {
      debug: false,
      expandLogs: false,
      preventDefault: false,
    }
  ) {
    this.options = options;

    if (this.options.debug) {
      console.warn(`[DEBUG] Maestro is running in debug mode.`);
    }

    this.directiveProxy = new MaestroDirectiveProxy({
      options,
      debugTrackEvent: this.debugTrackEvent,
    });
    document.addEventListener("mtr:track", (e) => this.handleTrackEvent(e));
    this.providers = [];
    this.transforms = {};
  }

  purgeEventQueue() {
    if (window.sessionStorage) {
      const mtrEventQueue = theme.maestro.eventQueue;

      const maestroEventQueue = JSON.parse(
        window.sessionStorage.getItem(mtrEventQueue) ?? "[]"
      );

      maestroEventQueue.forEach(({ event, data }) => {
        window.maestro.fireTrackEvent(event, data);
      });

      window.sessionStorage.removeItem(mtrEventQueue);
    }
  }

  debugTrackEvent(event, provider, transformedData) {
    const analyticsEventType = event.detail.analyticsEvent;
    const domEvent = event.detail.domEvent;
    const expandLogs = this.options.expandLogs;
    const groupType = expandLogs ? "group" : "groupCollapsed";
    const groupColors = [
      "color: white",
      "background: rgba(0, 100, 100, 0.6)",
      "border: 1px solid rgba(0, 100, 100, 1)",
      "border-radius: 3px",
      "padding: 2px 4px",
    ].join(";");

    console[groupType](
      `%c[DEBUG] Maestro Event: ${analyticsEventType}`,
      groupColors
    );
    console.group(`%cEvent Data`, groupColors);
    console.table(transformedData);
    console.groupEnd();
    console[groupType](`%cAdditional Details`, groupColors);
    console.info(event);
    console.info(event.currentTarget);
    if (provider) {
      console.info(provider.name);
    }
    console.groupEnd();
    console.groupEnd();

    if (this.options.preventDefault && domEvent?.preventDefault) {
      domEvent.preventDefault();
    }
  }

  handleTrackEvent(event) {
    const analyticsEventType = event.detail.analyticsEvent;
    this.providers.forEach(async (provider) => {
      if (provider[analyticsEventType]) {
        try {
          const transformedData = this.evaluateData(event.detail.data);

          if (this.options.debug) {
            this.debugTrackEvent(event, provider, transformedData);
          } else {
            console.info(`Firing ${provider.name} : ${analyticsEventType}`);
            provider[analyticsEventType](transformedData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        console.info(`Skipping ${provider.name} : ${analyticsEventType}`);
      }
    });
  }

  evaluateData(data) {
    if (typeof data === "string") {
      if (data.startsWith("$")) {
        const transformName = data.slice(1);
        console.info(`Transform ${transformName} called`);
        return this.transforms[transformName](data);
      } else {
        return data;
      }
    } else if (typeof data === "object") {
      const evaluatedData = {};
      Object.keys(data).forEach((key) => {
        if (key.startsWith("$")) {
          const transformName = key.slice(1);
          const entry = data[key];

          console.info(`Transform ${transformName} called`);
          return (evaluatedData[transformName] =
            this.transforms[transformName](entry));
        } else {
          evaluatedData[key] = data[key];
        }
      });
      return evaluatedData;
    } else {
      return data;
    }
  }

  fireTrackEvent(analyticsEvent, data) {
    const maestroEvent = new CustomEvent("mtr:track", {
      detail: {
        analyticsEvent,
        data,
      },
    });
    document.dispatchEvent(maestroEvent);
  }

  addAnalyticsProvider(provider) {
    if (!this.providers.find((p) => p.name === provider.name)) {
      this.providers.push(provider);
    }
  }

  addTransform(name, transform) {
    this.transforms[name] = transform;
  }
}
